import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromCheckoutReducer from '@pages/checkout-app/checkout-store/reducers/checkout.reducer';
import { CheckoutActions } from '@pages/checkout-app/checkout-store/actions';
import { ShopService } from '@app/services/shops/shop.service';
import { takeUntil, filter, map, startWith, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'checkout-layout',
  templateUrl: './checkout-layout.component.html',
  styleUrls: ['./checkout-layout.component.scss'],
  standalone: false,
})
export class CheckoutLayoutComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();

  constructor(
    private store: Store<fromCheckoutReducer.State>,
    private shopService: ShopService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.store.dispatch(CheckoutActions.loadCheckoutSettings());
    this.shopService.shop$.pipe(takeUntil(this.destroy$)).subscribe((shop) => {
      if (shop) {
        this.store.dispatch(CheckoutActions.loadPdqIqBaseShippingMethods({ shopId: shop.id }));
      }
    });

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects),
        startWith(this.router.url),
        map((url: string) => url.split('?')[0]),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe((path: string) => {
        if (path.includes('/convert/extensions')) {
          this.store.dispatch(CheckoutActions.loadExtensionsListLightweight());
        }
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
